import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const UpcomingEventIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 22 19'} {...props}>
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.63075 1.29541V2.42041H1.85053C0.867703 2.42041 0.0703125 3.17627 0.0703125 4.10791V5.79541H16.6857V4.10791C16.6857 3.17627 15.8883 2.42041 14.9055 2.42041H13.1253V1.29541C13.1253 0.673145 12.5949 0.17041 11.9384 0.17041C11.282 0.17041 10.7516 0.673145 10.7516 1.29541V2.42041H6.00438V1.29541C6.00438 0.673145 5.47402 0.17041 4.81757 0.17041C4.16111 0.17041 3.63075 0.673145 3.63075 1.29541ZM16.6857 6.92041H0.0703125V16.4829C0.0703125 17.4146 0.867703 18.1704 1.85053 18.1704H14.9055C15.8883 18.1704 16.6857 17.4146 16.6857 16.4829V6.92041Z"
        fill="#738198"
      />
      <path
        d="M21.4784 10.2508C21.4784 12.9266 19.3086 15.0959 16.6323 15.0959C13.9559 15.0959 11.7861 12.9271 11.7861 10.2508C11.7861 7.57446 13.9559 5.40576 16.6323 5.40576C19.3086 5.40576 21.4784 7.57502 21.4784 10.2508Z"
        fill="#02A9F7"
      />
      <path d="M19.1945 8.48888L15.6703 12.013L14.0684 10.4111" fill="#02A9F7" />
      <path
        d="M18.9473 8.24181C19.0837 8.10548 19.3051 8.10551 19.4415 8.24181C19.5778 8.37815 19.5778 8.59961 19.4415 8.73595L15.9171 12.2604C15.7809 12.3963 15.5602 12.3962 15.4239 12.2604L13.8214 10.6578L13.7764 10.6031C13.6872 10.4678 13.7024 10.2839 13.8214 10.1647C13.9407 10.0453 14.1253 10.0301 14.2608 10.1197L14.3155 10.1647L15.67 11.5192L18.9473 8.24181Z"
        fill="white"
      />
    </svg>
  </SvgIcon>
)
export default UpcomingEventIcon
